import { render, staticRenderFns } from "./SimpleCopperModel.vue?vue&type=template&id=21b142f1&lang=pug&"
import script from "./SimpleCopperModel.vue?vue&type=script&lang=js&"
export * from "./SimpleCopperModel.vue?vue&type=script&lang=js&"
import style0 from "./SimpleCopperModel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports